import styled from "styled-components";

export const InputField = styled.input`
  height: ${(props) => props.h};
  max-height: ${(props) => props.maxH};
  min-height: ${(props) => props.minH};
  width: ${(props) => props.w};
  max-width: ${(props) => props.maxW};
  min-width: ${(props) => props.minW};
  color: ${(props) => props.color};
  background: ${(props) => props.bg || "transparent"};
  padding: ${(props) => props.p};
  font-family: ${(props) => props.fontFamily || "medium"};
  font-size: ${(props) => props.fontSize};
  transition: 0.3s ease-out;

  border: none;
  border-bottom: 2px solid ${(props) => props.borderColor || props.color};

  &:placeholder {
    color: #26262645;
  }

  &:focus {
    outline: none;
  }

  &:-internal-autofill-selected {
    color: ${(props) => props.color} !important;
    font: ${(props) => props.fontFamily || "medium"} !important;
  }

  @media (max-width: 600px) {
    font-size: ${(props) => props.smallSize || "36px"};
    padding: ${(props) => props.smallSize && "20px 5px 10px"};
  }

  @media (min-width: 1020px) {
    width: ${(props) => props.largeW};
  }
`;
